import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../pages/navbar/navbar';

const AppLayout = () => (
  <>
    <Navbar />
    <Outlet />
  </>
);

export default AppLayout;
